"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARROW_ICON_ROTATION_VALUES = void 0;
const common_1 = require("../../common");
exports.ARROW_ICON_ROTATION_VALUES = {
    [common_1.ARROW_DIRECTION.up]: '180deg',
    [common_1.ARROW_DIRECTION.down]: '0',
    [common_1.ARROW_DIRECTION.left]: '90deg',
    [common_1.ARROW_DIRECTION.right]: '270deg'
};
//# sourceMappingURL=ArrowIconRotationValues.js.map